// AUTO-GENERATED from apps_games_stats/v2/proposed/*.csv by generate_tiers_ts.py.
// PROPOSED / not signed off — read only behind buildRecommendationQuery's useTiers flag.

export type GameTier = {
  ts_1080p_high_60: number | null; ts_1080p_high_hfr: number | null;
  ts_1440p_high_60: number | null; ts_4k_high_60: number | null;
  cb_1080p_high_60: number | null; cb_1080p_high_hfr: number | null;
  demand_class: string;
};

export type SoftwareTier = {
  cb_standard: number | null; ts_standard: number | null; ram_standard: number | null;
  cb_professional: number | null; ts_professional: number | null; ram_professional: number | null;
  primary_bottleneck: string; gpu_axis_confidence: string;
};

export const HEAVY_UE5_ANCHOR = {"ts_1080p_high_60": 13105, "ts_1440p_high_60": 16250, "cb": 900} as const;

export const GAME_TIERS: Record<string, GameTier> = {
 "counter-strike-2": {
  "ts_1080p_high_60": 4624,
  "ts_1080p_high_hfr": 9543,
  "ts_1440p_high_60": 8202,
  "ts_4k_high_60": 10967,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "apex-legends": {
  "ts_1080p_high_60": 6242,
  "ts_1080p_high_hfr": 12883,
  "ts_1440p_high_60": 11073,
  "ts_4k_high_60": 14805,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "pubg-battlegrounds": {
  "ts_1080p_high_60": 6242,
  "ts_1080p_high_hfr": 12883,
  "ts_1440p_high_60": 11073,
  "ts_4k_high_60": 14805,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "palworld": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "team-fortress-2": {
  "ts_1080p_high_60": 4624,
  "ts_1080p_high_hfr": 9543,
  "ts_1440p_high_60": 8202,
  "ts_4k_high_60": 10967,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "call-of-duty-modern-warfare-ii": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "new-world-aeternum": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "black-myth-wukong": {
  "ts_1080p_high_60": 11617,
  "ts_1080p_high_hfr": 21808,
  "ts_1440p_high_60": 14382,
  "ts_4k_high_60": 24602,
  "cb_1080p_high_60": 900,
  "cb_1080p_high_hfr": 1250,
  "demand_class": "heavy-ue5"
 },
 "grand-theft-auto-v": {
  "ts_1080p_high_60": 2657,
  "ts_1080p_high_hfr": 5500,
  "ts_1440p_high_60": 4102,
  "ts_4k_high_60": 7678,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "left-4-dead-2": {
  "ts_1080p_high_60": 1360,
  "ts_1080p_high_hfr": 2808,
  "ts_1440p_high_60": 2413,
  "ts_4k_high_60": 3227,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "unturned": {
  "ts_1080p_high_60": 1360,
  "ts_1080p_high_hfr": 2808,
  "ts_1440p_high_60": 2413,
  "ts_4k_high_60": 3227,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "lost-ark": {
  "ts_1080p_high_60": 2657,
  "ts_1080p_high_hfr": 5500,
  "ts_1440p_high_60": 4102,
  "ts_4k_high_60": 7678,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "war-thunder": {
  "ts_1080p_high_60": 6242,
  "ts_1080p_high_hfr": 12883,
  "ts_1440p_high_60": 11073,
  "ts_4k_high_60": 14805,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "monster-hunter-wilds": {
  "ts_1080p_high_60": 17298,
  "ts_1080p_high_hfr": 20178,
  "ts_1440p_high_60": 17298,
  "ts_4k_high_60": 24602,
  "cb_1080p_high_60": 900,
  "cb_1080p_high_hfr": 1250,
  "demand_class": "heavy-ue5"
 },
 "helldivers-2": {
  "ts_1080p_high_60": 8202,
  "ts_1080p_high_hfr": 17286,
  "ts_1440p_high_60": 10348,
  "ts_4k_high_60": 15889,
  "cb_1080p_high_60": 740,
  "cb_1080p_high_hfr": 1050,
  "demand_class": "modern-aaa"
 },
 "warframe": {
  "ts_1080p_high_60": 1669,
  "ts_1080p_high_hfr": 3444,
  "ts_1440p_high_60": 2960,
  "ts_4k_high_60": 3958,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "elden-ring": {
  "ts_1080p_high_60": 6604,
  "ts_1080p_high_hfr": 6604,
  "ts_1440p_high_60": 7064,
  "ts_4k_high_60": 14451,
  "cb_1080p_high_60": 740,
  "cb_1080p_high_hfr": 1050,
  "demand_class": "modern-aaa"
 },
 "terraria": {
  "ts_1080p_high_60": 1141,
  "ts_1080p_high_hfr": 2356,
  "ts_1440p_high_60": 2025,
  "ts_4k_high_60": 2707,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "path-of-exile-2": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "wallpaper-engine": {
  "ts_1080p_high_60": 1360,
  "ts_1080p_high_hfr": 2808,
  "ts_1440p_high_60": 2413,
  "ts_4k_high_60": 3227,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "baldur-s-gate-3": {
  "ts_1080p_high_60": 6738,
  "ts_1080p_high_hfr": 13289,
  "ts_1440p_high_60": 9050,
  "ts_4k_high_60": 16778,
  "cb_1080p_high_60": 740,
  "cb_1080p_high_hfr": 1050,
  "demand_class": "modern-aaa"
 },
 "brawlhalla": {
  "ts_1080p_high_60": 3770,
  "ts_1080p_high_hfr": 7780,
  "ts_1440p_high_60": 6687,
  "ts_4k_high_60": 8941,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "garry-s-mod": {
  "ts_1080p_high_60": 1669,
  "ts_1080p_high_hfr": 3444,
  "ts_1440p_high_60": 2960,
  "ts_4k_high_60": 3958,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "destiny-2": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "tom-clancy-s-rainbow-six-siege": {
  "ts_1080p_high_60": 6242,
  "ts_1080p_high_hfr": 12883,
  "ts_1440p_high_60": 11073,
  "ts_4k_high_60": 14805,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "rust": {
  "ts_1080p_high_60": 8342,
  "ts_1080p_high_hfr": 15635,
  "ts_1440p_high_60": 11812,
  "ts_4k_high_60": 24051,
  "cb_1080p_high_60": 1000,
  "cb_1080p_high_hfr": 1400,
  "demand_class": "sim-strategy"
 },
 "world-of-warships": {
  "ts_1080p_high_60": 4624,
  "ts_1080p_high_hfr": 9543,
  "ts_1440p_high_60": 8202,
  "ts_4k_high_60": 10967,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "ark-survival-evolved": {
  "ts_1080p_high_60": 8342,
  "ts_1080p_high_hfr": 15635,
  "ts_1440p_high_60": 11812,
  "ts_4k_high_60": 24051,
  "cb_1080p_high_60": 1000,
  "cb_1080p_high_hfr": 1400,
  "demand_class": "sim-strategy"
 },
 "stardew-valley": {
  "ts_1080p_high_60": 1141,
  "ts_1080p_high_hfr": 2356,
  "ts_1440p_high_60": 2025,
  "ts_4k_high_60": 2707,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "the-forest": {
  "ts_1080p_high_60": 2657,
  "ts_1080p_high_hfr": 5500,
  "ts_1440p_high_60": 4102,
  "ts_4k_high_60": 7678,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "war-robots-frontiers": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "path-of-exile": {
  "ts_1080p_high_60": 1669,
  "ts_1080p_high_hfr": 3444,
  "ts_1440p_high_60": 2960,
  "ts_4k_high_60": 3958,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "payday-2": {
  "ts_1080p_high_60": 1669,
  "ts_1080p_high_hfr": 3444,
  "ts_1440p_high_60": 2960,
  "ts_4k_high_60": 3958,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "warface-clutch": {
  "ts_1080p_high_60": 4624,
  "ts_1080p_high_hfr": 9543,
  "ts_1440p_high_60": 8202,
  "ts_4k_high_60": 10967,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "grand-theft-auto-iv-complete-edition": {
  "ts_1080p_high_60": 1669,
  "ts_1080p_high_hfr": 3444,
  "ts_1440p_high_60": 2960,
  "ts_4k_high_60": 3958,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "last-epoch": {
  "ts_1080p_high_60": 2657,
  "ts_1080p_high_hfr": 5500,
  "ts_1440p_high_60": 4102,
  "ts_4k_high_60": 7678,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "half-life-2-lost-coast": {
  "ts_1080p_high_60": 1141,
  "ts_1080p_high_hfr": 2356,
  "ts_1440p_high_60": 2025,
  "ts_4k_high_60": 2707,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "cyberpunk-2077": {
  "ts_1080p_high_60": 6858,
  "ts_1080p_high_hfr": 18922,
  "ts_1440p_high_60": 9816,
  "ts_4k_high_60": 19765,
  "cb_1080p_high_60": 740,
  "cb_1080p_high_hfr": 1050,
  "demand_class": "modern-aaa"
 },
 "dead-by-daylight": {
  "ts_1080p_high_60": 2657,
  "ts_1080p_high_hfr": 5500,
  "ts_1440p_high_60": 4102,
  "ts_4k_high_60": 7678,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "hogwarts-legacy": {
  "ts_1080p_high_60": 8598,
  "ts_1080p_high_hfr": 13532,
  "ts_1440p_high_60": 8598,
  "ts_4k_high_60": 12709,
  "cb_1080p_high_60": 740,
  "cb_1080p_high_hfr": 1050,
  "demand_class": "modern-aaa"
 },
 "vrchat": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "the-witcher-3-wild-hunt": {
  "ts_1080p_high_60": 4407,
  "ts_1080p_high_hfr": 9122,
  "ts_1440p_high_60": 6803,
  "ts_4k_high_60": 13136,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "among-us": {
  "ts_1080p_high_60": 1141,
  "ts_1080p_high_hfr": 2356,
  "ts_1440p_high_60": 2025,
  "ts_4k_high_60": 2707,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "fall-guys": {
  "ts_1080p_high_60": 4624,
  "ts_1080p_high_hfr": 9543,
  "ts_1440p_high_60": 8202,
  "ts_4k_high_60": 10967,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "borderlands-2": {
  "ts_1080p_high_60": 1669,
  "ts_1080p_high_hfr": 3444,
  "ts_1440p_high_60": 2960,
  "ts_4k_high_60": 3958,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "euro-truck-simulator-2": {
  "ts_1080p_high_60": 6518,
  "ts_1080p_high_hfr": 12216,
  "ts_1440p_high_60": 9229,
  "ts_4k_high_60": 18792,
  "cb_1080p_high_60": 1000,
  "cb_1080p_high_hfr": 1400,
  "demand_class": "sim-strategy"
 },
 "valheim": {
  "ts_1080p_high_60": 2657,
  "ts_1080p_high_hfr": 5500,
  "ts_1440p_high_60": 4102,
  "ts_4k_high_60": 7678,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "phasmophobia": {
  "ts_1080p_high_60": 1837,
  "ts_1080p_high_hfr": 3790,
  "ts_1440p_high_60": 3258,
  "ts_4k_high_60": 4356,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "paladins": {
  "ts_1080p_high_60": 4624,
  "ts_1080p_high_hfr": 9543,
  "ts_1440p_high_60": 8202,
  "ts_4k_high_60": 10967,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "naraka-bladepoint": {
  "ts_1080p_high_60": 6242,
  "ts_1080p_high_hfr": 12883,
  "ts_1440p_high_60": 11073,
  "ts_4k_high_60": 14805,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "half-life-2-deathmatch": {
  "ts_1080p_high_60": 3468,
  "ts_1080p_high_hfr": 7157,
  "ts_1440p_high_60": 6152,
  "ts_4k_high_60": 8225,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "half-life": {
  "ts_1080p_high_60": 1141,
  "ts_1080p_high_hfr": 2356,
  "ts_1440p_high_60": 2025,
  "ts_4k_high_60": 2707,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "monster-hunter-world": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "heroes-generals": {
  "ts_1080p_high_60": 4624,
  "ts_1080p_high_hfr": 9543,
  "ts_1440p_high_60": 8202,
  "ts_4k_high_60": 10967,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "rocket-league": {
  "ts_1080p_high_60": 4624,
  "ts_1080p_high_hfr": 9543,
  "ts_1440p_high_60": 8202,
  "ts_4k_high_60": 10967,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "project-zomboid": {
  "ts_1080p_high_60": 4888,
  "ts_1080p_high_hfr": 9162,
  "ts_1440p_high_60": 6922,
  "ts_4k_high_60": 14094,
  "cb_1080p_high_60": 1000,
  "cb_1080p_high_hfr": 1400,
  "demand_class": "sim-strategy"
 },
 "lethal-company": {
  "ts_1080p_high_60": 1360,
  "ts_1080p_high_hfr": 2808,
  "ts_1440p_high_60": 2413,
  "ts_4k_high_60": 3227,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "red-dead-redemption-2": {
  "ts_1080p_high_60": 8119,
  "ts_1080p_high_hfr": 16013,
  "ts_1440p_high_60": 10574,
  "ts_4k_high_60": 18991,
  "cb_1080p_high_60": 740,
  "cb_1080p_high_hfr": 1050,
  "demand_class": "modern-aaa"
 },
 "battlefield-2042": {
  "ts_1080p_high_60": 9159,
  "ts_1080p_high_hfr": 18064,
  "ts_1440p_high_60": 11929,
  "ts_4k_high_60": 21424,
  "cb_1080p_high_60": 740,
  "cb_1080p_high_hfr": 1050,
  "demand_class": "modern-aaa"
 },
 "halo-infinite": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "raft": {
  "ts_1080p_high_60": 1669,
  "ts_1080p_high_hfr": 3444,
  "ts_1440p_high_60": 2960,
  "ts_4k_high_60": 3958,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "smite": {
  "ts_1080p_high_60": 4624,
  "ts_1080p_high_hfr": 9543,
  "ts_1440p_high_60": 8202,
  "ts_4k_high_60": 10967,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "world-of-tanks-blitz": {
  "ts_1080p_high_60": 3770,
  "ts_1080p_high_hfr": 7780,
  "ts_1440p_high_60": 6687,
  "ts_4k_high_60": 8941,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "counter-strike": {
  "ts_1080p_high_60": 3468,
  "ts_1080p_high_hfr": 7157,
  "ts_1440p_high_60": 6152,
  "ts_4k_high_60": 8225,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "counter-strike-source": {
  "ts_1080p_high_60": 3468,
  "ts_1080p_high_hfr": 7157,
  "ts_1440p_high_60": 6152,
  "ts_4k_high_60": 8225,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "schedule-i": {
  "ts_1080p_high_60": 1837,
  "ts_1080p_high_hfr": 3790,
  "ts_1440p_high_60": 3258,
  "ts_4k_high_60": 4356,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "ring-of-elysium": {
  "ts_1080p_high_60": 6242,
  "ts_1080p_high_hfr": 12883,
  "ts_1440p_high_60": 11073,
  "ts_4k_high_60": 14805,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "portal": {
  "ts_1080p_high_60": 1141,
  "ts_1080p_high_hfr": 2356,
  "ts_1440p_high_60": 2025,
  "ts_4k_high_60": 2707,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "the-sims-4": {
  "ts_1080p_high_60": 1669,
  "ts_1080p_high_hfr": 3444,
  "ts_1440p_high_60": 2960,
  "ts_4k_high_60": 3958,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "black-squad": {
  "ts_1080p_high_60": 4624,
  "ts_1080p_high_hfr": 9543,
  "ts_1440p_high_60": 8202,
  "ts_4k_high_60": 10967,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "don-t-starve-together": {
  "ts_1080p_high_60": 1360,
  "ts_1080p_high_hfr": 2808,
  "ts_1440p_high_60": 2413,
  "ts_4k_high_60": 3227,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "dying-light": {
  "ts_1080p_high_60": 2657,
  "ts_1080p_high_hfr": 5500,
  "ts_1440p_high_60": 4102,
  "ts_4k_high_60": 7678,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "human-fall-flat": {
  "ts_1080p_high_60": 1360,
  "ts_1080p_high_hfr": 2808,
  "ts_1440p_high_60": 2413,
  "ts_4k_high_60": 3227,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "7-days-to-die": {
  "ts_1080p_high_60": 6518,
  "ts_1080p_high_hfr": 12216,
  "ts_1440p_high_60": 9229,
  "ts_4k_high_60": 18792,
  "cb_1080p_high_60": 1000,
  "cb_1080p_high_hfr": 1400,
  "demand_class": "sim-strategy"
 },
 "counter-strike-condition-zero": {
  "ts_1080p_high_60": 3468,
  "ts_1080p_high_hfr": 7157,
  "ts_1440p_high_60": 6152,
  "ts_4k_high_60": 8225,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "efootball-2025": {
  "ts_1080p_high_60": 6242,
  "ts_1080p_high_hfr": 12883,
  "ts_1440p_high_60": 11073,
  "ts_4k_high_60": 14805,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "street-warriors-online": {
  "ts_1080p_high_60": 3770,
  "ts_1080p_high_hfr": 7780,
  "ts_1440p_high_60": 6687,
  "ts_4k_high_60": 8941,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "z1-battle-royale": {
  "ts_1080p_high_60": 4624,
  "ts_1080p_high_hfr": 9543,
  "ts_1440p_high_60": 8202,
  "ts_4k_high_60": 10967,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "hunt-showdown-1896": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "sekiro-shadows-die-twice-goty-edition": {
  "ts_1080p_high_60": 2657,
  "ts_1080p_high_hfr": 5500,
  "ts_1440p_high_60": 4102,
  "ts_4k_high_60": 7678,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "cybercorp": {
  "ts_1080p_high_60": 4624,
  "ts_1080p_high_hfr": 9543,
  "ts_1440p_high_60": 8202,
  "ts_4k_high_60": 10967,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "half-life-2": {
  "ts_1080p_high_60": 1141,
  "ts_1080p_high_hfr": 2356,
  "ts_1440p_high_60": 2025,
  "ts_4k_high_60": 2707,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "arma-3": {
  "ts_1080p_high_60": 6518,
  "ts_1080p_high_hfr": 12216,
  "ts_1440p_high_60": 9229,
  "ts_4k_high_60": 18792,
  "cb_1080p_high_60": 1000,
  "cb_1080p_high_hfr": 1400,
  "demand_class": "sim-strategy"
 },
 "sons-of-the-forest": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "grim-dawn": {
  "ts_1080p_high_60": 1669,
  "ts_1080p_high_hfr": 3444,
  "ts_1440p_high_60": 2960,
  "ts_4k_high_60": 3958,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "cities-skylines": {
  "ts_1080p_high_60": 4888,
  "ts_1080p_high_hfr": 9162,
  "ts_1440p_high_60": 6922,
  "ts_4k_high_60": 14094,
  "cb_1080p_high_60": 1000,
  "cb_1080p_high_hfr": 1400,
  "demand_class": "sim-strategy"
 },
 "mount-blade-ii-bannerlord": {
  "ts_1080p_high_60": 6518,
  "ts_1080p_high_hfr": 12216,
  "ts_1440p_high_60": 9229,
  "ts_4k_high_60": 18792,
  "cb_1080p_high_60": 1000,
  "cb_1080p_high_hfr": 1400,
  "demand_class": "sim-strategy"
 },
 "sid-meier-s-civilization-v": {
  "ts_1080p_high_60": 1360,
  "ts_1080p_high_hfr": 2808,
  "ts_1440p_high_60": 2413,
  "ts_4k_high_60": 3227,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "trove": {
  "ts_1080p_high_60": 3770,
  "ts_1080p_high_hfr": 7780,
  "ts_1440p_high_60": 6687,
  "ts_4k_high_60": 8941,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "sid-meier-s-civilization-vi": {
  "ts_1080p_high_60": 4888,
  "ts_1080p_high_hfr": 9162,
  "ts_1440p_high_60": 6922,
  "ts_4k_high_60": 14094,
  "cb_1080p_high_60": 1000,
  "cb_1080p_high_hfr": 1400,
  "demand_class": "sim-strategy"
 },
 "fallout-4": {
  "ts_1080p_high_60": 2657,
  "ts_1080p_high_hfr": 5500,
  "ts_1440p_high_60": 4102,
  "ts_4k_high_60": 7678,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "life-is-strange-2": {
  "ts_1080p_high_60": 1669,
  "ts_1080p_high_hfr": 3444,
  "ts_1440p_high_60": 2960,
  "ts_4k_high_60": 3958,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "warhammer-40-000-rogue-trader": {
  "ts_1080p_high_60": 2657,
  "ts_1080p_high_hfr": 5500,
  "ts_1440p_high_60": 4102,
  "ts_4k_high_60": 7678,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "battlefield-v": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "r-e-p-o": {
  "ts_1080p_high_60": 1360,
  "ts_1080p_high_hfr": 2808,
  "ts_1440p_high_60": 2413,
  "ts_4k_high_60": 3227,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "dayz": {
  "ts_1080p_high_60": 6518,
  "ts_1080p_high_hfr": 12216,
  "ts_1440p_high_60": 9229,
  "ts_4k_high_60": 18792,
  "cb_1080p_high_60": 1000,
  "cb_1080p_high_hfr": 1400,
  "demand_class": "sim-strategy"
 },
 "satisfactory": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "nba-2k20": {
  "ts_1080p_high_60": 4624,
  "ts_1080p_high_hfr": 9543,
  "ts_1440p_high_60": 8202,
  "ts_4k_high_60": 10967,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "risk-of-rain-2": {
  "ts_1080p_high_60": 1360,
  "ts_1080p_high_hfr": 2808,
  "ts_1440p_high_60": 2413,
  "ts_4k_high_60": 3227,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "ea-sports-fifa-23": {
  "ts_1080p_high_60": 6242,
  "ts_1080p_high_hfr": 12883,
  "ts_1440p_high_60": 11073,
  "ts_4k_high_60": 14805,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "minecraft": {
  "ts_1080p_high_60": 2551,
  "ts_1080p_high_hfr": 5280,
  "ts_1440p_high_60": 3938,
  "ts_4k_high_60": 7370,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "roblox": {
  "ts_1080p_high_60": 1141,
  "ts_1080p_high_hfr": 2356,
  "ts_1440p_high_60": 2025,
  "ts_4k_high_60": 2707,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "fortnite": {
  "ts_1080p_high_60": 6242,
  "ts_1080p_high_hfr": 12883,
  "ts_1440p_high_60": 11073,
  "ts_4k_high_60": 14805,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "league-of-legends": {
  "ts_1080p_high_60": 4624,
  "ts_1080p_high_hfr": 9543,
  "ts_1440p_high_60": 8202,
  "ts_4k_high_60": 10967,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "valorant": {
  "ts_1080p_high_60": 4624,
  "ts_1080p_high_hfr": 9543,
  "ts_1440p_high_60": 8202,
  "ts_4k_high_60": 10967,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "overwatch-2": {
  "ts_1080p_high_60": 6242,
  "ts_1080p_high_hfr": 12883,
  "ts_1440p_high_60": 11073,
  "ts_4k_high_60": 14805,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "dota-2": {
  "ts_1080p_high_60": 4624,
  "ts_1080p_high_hfr": 9543,
  "ts_1440p_high_60": 8202,
  "ts_4k_high_60": 10967,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "genshin-impact": {
  "ts_1080p_high_60": 2657,
  "ts_1080p_high_hfr": 5500,
  "ts_1440p_high_60": 4102,
  "ts_4k_high_60": 7678,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "world-of-warcraft": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "diablo-iv": {
  "ts_1080p_high_60": 3234,
  "ts_1080p_high_hfr": 6243,
  "ts_1440p_high_60": 5018,
  "ts_4k_high_60": 9344,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "marvel-rivals": {
  "ts_1080p_high_60": 6242,
  "ts_1080p_high_hfr": 12883,
  "ts_1440p_high_60": 11073,
  "ts_4k_high_60": 14805,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "call-of-duty-warzone": {
  "ts_1080p_high_60": 6242,
  "ts_1080p_high_hfr": 12883,
  "ts_1440p_high_60": 11073,
  "ts_4k_high_60": 14805,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "escape-from-tarkov": {
  "ts_1080p_high_60": 8342,
  "ts_1080p_high_hfr": 15635,
  "ts_1440p_high_60": 11812,
  "ts_4k_high_60": 24051,
  "cb_1080p_high_60": 1000,
  "cb_1080p_high_hfr": 1400,
  "demand_class": "sim-strategy"
 },
 "forza-horizon-5": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 8398,
  "ts_1440p_high_60": 4732,
  "ts_4k_high_60": 7265,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "final-fantasy-xiv": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "sea-of-thieves": {
  "ts_1080p_high_60": 2657,
  "ts_1080p_high_hfr": 5500,
  "ts_1440p_high_60": 4102,
  "ts_4k_high_60": 7678,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "starfield": {
  "ts_1080p_high_60": 14280,
  "ts_1080p_high_hfr": 24602,
  "ts_1440p_high_60": 18598,
  "ts_4k_high_60": 18827,
  "cb_1080p_high_60": 740,
  "cb_1080p_high_hfr": 1050,
  "demand_class": "modern-aaa"
 },
 "god-of-war-ragnarok": {
  "ts_1080p_high_60": 8119,
  "ts_1080p_high_hfr": 16013,
  "ts_1440p_high_60": 10574,
  "ts_4k_high_60": 18991,
  "cb_1080p_high_60": 740,
  "cb_1080p_high_hfr": 1050,
  "demand_class": "modern-aaa"
 },
 "assassins-creed-shadows": {
  "ts_1080p_high_60": 13105,
  "ts_1080p_high_hfr": 24602,
  "ts_1440p_high_60": 16224,
  "ts_4k_high_60": 24602,
  "cb_1080p_high_60": 900,
  "cb_1080p_high_hfr": 1250,
  "demand_class": "heavy-ue5"
 },
 "honkai-star-rail": {
  "ts_1080p_high_60": 2657,
  "ts_1080p_high_hfr": 5500,
  "ts_1440p_high_60": 4102,
  "ts_4k_high_60": 7678,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "fc-26": {
  "ts_1080p_high_60": 6242,
  "ts_1080p_high_hfr": 12883,
  "ts_1440p_high_60": 11073,
  "ts_4k_high_60": 14805,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "arc-raiders": {
  "ts_1080p_high_60": 6712,
  "ts_1080p_high_hfr": 24602,
  "ts_1440p_high_60": 9172,
  "ts_4k_high_60": 17266,
  "cb_1080p_high_60": 900,
  "cb_1080p_high_hfr": 1250,
  "demand_class": "heavy-ue5"
 },
 "delta-force": {
  "ts_1080p_high_60": 6242,
  "ts_1080p_high_hfr": 12883,
  "ts_1440p_high_60": 11073,
  "ts_4k_high_60": 14805,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "battlefield-6": {
  "ts_1080p_high_60": 7198,
  "ts_1080p_high_hfr": 14787,
  "ts_1440p_high_60": 11155,
  "ts_4k_high_60": 18516,
  "cb_1080p_high_60": 900,
  "cb_1080p_high_hfr": 1250,
  "demand_class": "heavy-ue5"
 },
 "call-of-duty-black-ops-6": {
  "ts_1080p_high_60": 4731,
  "ts_1080p_high_hfr": 13036,
  "ts_1440p_high_60": 10374,
  "ts_4k_high_60": 18516,
  "cb_1080p_high_60": 740,
  "cb_1080p_high_hfr": 1050,
  "demand_class": "modern-aaa"
 },
 "the-finals": {
  "ts_1080p_high_60": 6242,
  "ts_1080p_high_hfr": 12883,
  "ts_1440p_high_60": 11073,
  "ts_4k_high_60": 14805,
  "cb_1080p_high_60": 600,
  "cb_1080p_high_hfr": 980,
  "demand_class": "esports"
 },
 "kingdom-come-deliverance-2": {
  "ts_1080p_high_60": 13339,
  "ts_1080p_high_hfr": 24602,
  "ts_1440p_high_60": 13339,
  "ts_4k_high_60": 24602,
  "cb_1080p_high_60": 740,
  "cb_1080p_high_hfr": 1050,
  "demand_class": "modern-aaa"
 },
 "clair-obscur-expedition-33": {
  "ts_1080p_high_60": 8119,
  "ts_1080p_high_hfr": 16013,
  "ts_1440p_high_60": 10574,
  "ts_4k_high_60": 18991,
  "cb_1080p_high_60": 740,
  "cb_1080p_high_hfr": 1050,
  "demand_class": "modern-aaa"
 },
 "split-fiction": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "elden-ring-nightreign": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "stalker-2": {
  "ts_1080p_high_60": 20078,
  "ts_1080p_high_hfr": 24602,
  "ts_1440p_high_60": 20574,
  "ts_4k_high_60": 24602,
  "cb_1080p_high_60": 900,
  "cb_1080p_high_hfr": 1250,
  "demand_class": "heavy-ue5"
 },
 "dune-awakening": {
  "ts_1080p_high_60": 10073,
  "ts_1080p_high_hfr": 19867,
  "ts_1440p_high_60": 13119,
  "ts_4k_high_60": 23563,
  "cb_1080p_high_60": 740,
  "cb_1080p_high_hfr": 1050,
  "demand_class": "modern-aaa"
 },
 "wuthering-waves": {
  "ts_1080p_high_60": 2657,
  "ts_1080p_high_hfr": 5500,
  "ts_1440p_high_60": 4102,
  "ts_4k_high_60": 7678,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "throne-and-liberty": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "once-human": {
  "ts_1080p_high_60": 3401,
  "ts_1080p_high_hfr": 7040,
  "ts_1440p_high_60": 5250,
  "ts_4k_high_60": 9827,
  "cb_1080p_high_60": 620,
  "cb_1080p_high_hfr": 900,
  "demand_class": "mid-3d"
 },
 "sid-meier-s-civilization-vii": {
  "ts_1080p_high_60": 6518,
  "ts_1080p_high_hfr": 12216,
  "ts_1440p_high_60": 9229,
  "ts_4k_high_60": 18792,
  "cb_1080p_high_60": 1000,
  "cb_1080p_high_hfr": 1400,
  "demand_class": "sim-strategy"
 },
 "avowed": {
  "ts_1080p_high_60": 13105,
  "ts_1080p_high_hfr": 24602,
  "ts_1440p_high_60": 16224,
  "ts_4k_high_60": 24602,
  "cb_1080p_high_60": 900,
  "cb_1080p_high_hfr": 1250,
  "demand_class": "heavy-ue5"
 },
 "borderlands-4": {
  "ts_1080p_high_60": 13105,
  "ts_1080p_high_hfr": 24602,
  "ts_1440p_high_60": 16224,
  "ts_4k_high_60": 24602,
  "cb_1080p_high_60": 900,
  "cb_1080p_high_hfr": 1250,
  "demand_class": "heavy-ue5"
 },
 "marvels-spider-man-2": {
  "ts_1080p_high_60": 13105,
  "ts_1080p_high_hfr": 24602,
  "ts_1440p_high_60": 16224,
  "ts_4k_high_60": 24602,
  "cb_1080p_high_60": 900,
  "cb_1080p_high_hfr": 1250,
  "demand_class": "heavy-ue5"
 },
 "peak": {
  "ts_1080p_high_60": 1669,
  "ts_1080p_high_hfr": 3444,
  "ts_1440p_high_60": 2960,
  "ts_4k_high_60": 3958,
  "cb_1080p_high_60": 300,
  "cb_1080p_high_hfr": 480,
  "demand_class": "indie-light"
 },
 "inzoi": {
  "ts_1080p_high_60": 8342,
  "ts_1080p_high_hfr": 15635,
  "ts_1440p_high_60": 11812,
  "ts_4k_high_60": 24051,
  "cb_1080p_high_60": 1000,
  "cb_1080p_high_hfr": 1400,
  "demand_class": "sim-strategy"
 },
 "resident-evil-requiem": {
  "ts_1080p_high_60": 8119,
  "ts_1080p_high_hfr": 16664,
  "ts_1440p_high_60": 14362,
  "ts_4k_high_60": 23356,
  "cb_1080p_high_60": 740,
  "cb_1080p_high_hfr": 1050,
  "demand_class": "modern-aaa"
 }
};

export const SOFTWARE_TIERS: Record<string, SoftwareTier> = {
 "netflix": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "youtube": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "instagram": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "facebook": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "x-twitter": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "tiktok": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "reddit": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "twitch": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "linkedin": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "pinterest": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "canva": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "google-drive": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "google-meet": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "spotify-web": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "notion-web": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "slack": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "microsoft-teams": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "zoom": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "discord": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "gmail": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "outlook": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "whatsapp-desktop": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "telegram-desktop": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "signal-desktop": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "skype": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "adobe-photoshop": {
  "cb_standard": 775,
  "ts_standard": 3466,
  "ram_standard": 16,
  "cb_professional": 981,
  "ts_professional": 9999,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "proxy"
 },
 "adobe-illustrator": {
  "cb_standard": 604,
  "ts_standard": 1452,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 3466,
  "ram_professional": 16,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "proxy"
 },
 "adobe-premiere-pro": {
  "cb_standard": 920,
  "ts_standard": 5582,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 64,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "proxy"
 },
 "adobe-after-effects": {
  "cb_standard": 920,
  "ts_standard": 5582,
  "ram_standard": 32,
  "cb_professional": 2303,
  "ts_professional": 9999,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "proxy"
 },
 "adobe-lightroom": {
  "cb_standard": 775,
  "ts_standard": 3466,
  "ram_standard": 16,
  "cb_professional": 981,
  "ts_professional": 9999,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "proxy"
 },
 "adobe-xd": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "adobe-acrobat": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "davinci-resolve": {
  "cb_standard": 920,
  "ts_standard": 7788,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 16195,
  "ram_professional": 32,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "proxy"
 },
 "blender": {
  "cb_standard": 981,
  "ts_standard": 9999,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 16195,
  "ram_professional": 64,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "good"
 },
 "autocad": {
  "cb_standard": 604,
  "ts_standard": 3466,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 64,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "proxy"
 },
 "fusion-360": {
  "cb_standard": 604,
  "ts_standard": 1452,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 4808,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "proxy"
 },
 "figma": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "obs-studio": {
  "cb_standard": 604,
  "ts_standard": 3466,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 7788,
  "ram_professional": 16,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "poor"
 },
 "gimp": {
  "cb_standard": 775,
  "ts_standard": 3466,
  "ram_standard": 16,
  "cb_professional": 981,
  "ts_professional": 7788,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "proxy"
 },
 "inkscape": {
  "cb_standard": 604,
  "ts_standard": 1452,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 3466,
  "ram_professional": 16,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "proxy"
 },
 "cinema-4d": {
  "cb_standard": 981,
  "ts_standard": 7788,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 16195,
  "ram_professional": 64,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "proxy"
 },
 "capcut": {
  "cb_standard": 920,
  "ts_standard": 5582,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 32,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "proxy"
 },
 "kdenlive": {
  "cb_standard": 920,
  "ts_standard": 5582,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 32,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "proxy"
 },
 "handbrake": {
  "cb_standard": 775,
  "ts_standard": 3466,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 7788,
  "ram_professional": 16,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "poor"
 },
 "microsoft-word": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "microsoft-excel": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "microsoft-powerpoint": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "power-bi-desktop": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "libreoffice": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "tableau-desktop": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "obsidian": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "notion-desktop": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "google-workspace": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "airtable": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "onenote": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "evernote": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "spotify-desktop": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "vlc-media-player": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "kodi": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "plex": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "audacity": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "apple-music": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "tidal": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "mpc-hc": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "winamp": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "visual-studio-code": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "intellij-idea": {
  "cb_standard": 775,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "pycharm": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "webstorm": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "clion": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "android-studio": {
  "cb_standard": 775,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "visual-studio-2022": {
  "cb_standard": 775,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "github-desktop": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "docker-desktop": {
  "cb_standard": 775,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "postman": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "sublime-text": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "cursor": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "google-chrome": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "mozilla-firefox": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "microsoft-edge": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "virtualbox": {
  "cb_standard": 775,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "vmware-workstation": {
  "cb_standard": 775,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "1password": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "bitwarden": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "dropbox": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "onedrive": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "filezilla": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "7-zip": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "sharex": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "zoom-video": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "chatgpt": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "claude": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "google-gemini": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "microsoft-copilot": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "perplexity": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "grammarly": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "trello": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "asana": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "jira": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "monday": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "clickup": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "miro": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "confluence": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "cisco-webex": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "loom": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "salesforce": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "hubspot": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "quickbooks": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "google-docs": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "google-sheets": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "google-calendar": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "quizlet": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "anki": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "zotero": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "overleaf": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "solidworks": {
  "cb_standard": 775,
  "ts_standard": 4808,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 64,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "proxy"
 },
 "ansys-workbench": {
  "cb_standard": 981,
  "ts_standard": 345,
  "ram_standard": 32,
  "cb_professional": 2303,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "matlab-simulink": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "autodesk-fusion-360": {
  "cb_standard": 604,
  "ts_standard": 1452,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 4808,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "proxy"
 },
 "abaqus": {
  "cb_standard": 981,
  "ts_standard": 345,
  "ram_standard": 32,
  "cb_professional": 2303,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "excel-python": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "autodesk-revit": {
  "cb_standard": 775,
  "ts_standard": 7788,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 13562,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "proxy"
 },
 "autodesk-inventor": {
  "cb_standard": 775,
  "ts_standard": 4808,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 64,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "proxy"
 },
 "comsol-multiphysics": {
  "cb_standard": 981,
  "ts_standard": 345,
  "ram_standard": 32,
  "cb_professional": 2303,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "catia": {
  "cb_standard": 775,
  "ts_standard": 4808,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 64,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "proxy"
 },
 "rhino-3d": {
  "cb_standard": 981,
  "ts_standard": 7788,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 16195,
  "ram_professional": 64,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "proxy"
 },
 "sketchup": {
  "cb_standard": 604,
  "ts_standard": 3466,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 4808,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "proxy"
 },
 "ibm-spss-statistics": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "microsoft-365": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "siemens-nx": {
  "cb_standard": 775,
  "ts_standard": 4808,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 64,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "proxy"
 },
 "ptc-creo": {
  "cb_standard": 775,
  "ts_standard": 4808,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 64,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "proxy"
 },
 "openfoam": {
  "cb_standard": 981,
  "ts_standard": 345,
  "ram_standard": 32,
  "cb_professional": 2303,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "aspen-plus": {
  "cb_standard": 981,
  "ts_standard": 345,
  "ram_standard": 32,
  "cb_professional": 2303,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "aspen-hysys": {
  "cb_standard": 981,
  "ts_standard": 345,
  "ram_standard": 32,
  "cb_professional": 2303,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "gproms": {
  "cb_standard": 981,
  "ts_standard": 345,
  "ram_standard": 32,
  "cb_professional": 2303,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "labview": {
  "cb_standard": 775,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "ni-multisim": {
  "cb_standard": 775,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "orcad-pspice": {
  "cb_standard": 775,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "altium-designer": {
  "cb_standard": 775,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "cadence-virtuoso": {
  "cb_standard": 775,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "kicad": {
  "cb_standard": 604,
  "ts_standard": 3466,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 4808,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "proxy"
 },
 "ltspice": {
  "cb_standard": 775,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "autocad-civil-3d": {
  "cb_standard": 775,
  "ts_standard": 7788,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 13562,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "proxy"
 },
 "tekla-structures": {
  "cb_standard": 775,
  "ts_standard": 7788,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 13562,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "proxy"
 },
 "sap2000-etabs": {
  "cb_standard": 981,
  "ts_standard": 345,
  "ram_standard": 32,
  "cb_professional": 2303,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "autodesk-robot-lusas": {
  "cb_standard": 981,
  "ts_standard": 345,
  "ram_standard": 32,
  "cb_professional": 2303,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "plaxis": {
  "cb_standard": 981,
  "ts_standard": 345,
  "ram_standard": 32,
  "cb_professional": 2303,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "archicad": {
  "cb_standard": 775,
  "ts_standard": 7788,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 13562,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "proxy"
 },
 "enscape": {
  "cb_standard": 775,
  "ts_standard": 7788,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 11616,
  "ram_professional": 32,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "good"
 },
 "lumion": {
  "cb_standard": 920,
  "ts_standard": 11616,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 18516,
  "ram_professional": 64,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "good"
 },
 "twinmotion": {
  "cb_standard": 775,
  "ts_standard": 7788,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 16195,
  "ram_professional": 32,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "good"
 },
 "v-ray": {
  "cb_standard": 981,
  "ts_standard": 7788,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 16195,
  "ram_professional": 64,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "proxy"
 },
 "3ds-max": {
  "cb_standard": 981,
  "ts_standard": 7788,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 16195,
  "ram_professional": 64,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "proxy"
 },
 "keyshot": {
  "cb_standard": 981,
  "ts_standard": 7788,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 16195,
  "ram_professional": 64,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "proxy"
 },
 "autodesk-alias": {
  "cb_standard": 775,
  "ts_standard": 4808,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 64,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "proxy"
 },
 "adobe-indesign": {
  "cb_standard": 604,
  "ts_standard": 1452,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 3466,
  "ram_professional": 16,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "proxy"
 },
 "adobe-audition": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "avid-media-composer": {
  "cb_standard": 920,
  "ts_standard": 5582,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 32,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "proxy"
 },
 "final-cut-pro": {
  "cb_standard": 920,
  "ts_standard": 5582,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 32,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "proxy"
 },
 "adobe-creative-cloud": {
  "cb_standard": 775,
  "ts_standard": 3466,
  "ram_standard": 16,
  "cb_professional": 981,
  "ts_professional": 7788,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "proxy"
 },
 "procreate": {
  "cb_standard": 775,
  "ts_standard": 3466,
  "ram_standard": 16,
  "cb_professional": 981,
  "ts_professional": 7788,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "proxy"
 },
 "clo3d": {
  "cb_standard": 604,
  "ts_standard": 1452,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 3466,
  "ram_professional": 16,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "proxy"
 },
 "touchdesigner": {
  "cb_standard": 920,
  "ts_standard": 11616,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 18516,
  "ram_professional": 64,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "good"
 },
 "logic-pro": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "pro-tools": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "ableton-live": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "sibelius-dorico": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "cubase-reaper": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "max-msp": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "kontakt": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "arcgis-pro": {
  "cb_standard": 775,
  "ts_standard": 4808,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 13562,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "proxy"
 },
 "qgis": {
  "cb_standard": 775,
  "ts_standard": 4808,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "proxy"
 },
 "envi-erdas": {
  "cb_standard": 775,
  "ts_standard": 4808,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "proxy"
 },
 "agisoft-metashape": {
  "cb_standard": 981,
  "ts_standard": 7788,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 16195,
  "ram_professional": 64,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "proxy"
 },
 "petrel": {
  "cb_standard": 775,
  "ts_standard": 4808,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "proxy"
 },
 "leapfrog": {
  "cb_standard": 775,
  "ts_standard": 4808,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "proxy"
 },
 "surfer-grapher": {
  "cb_standard": 775,
  "ts_standard": 4808,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "proxy"
 },
 "google-earth-engine": {
  "cb_standard": 775,
  "ts_standard": 4808,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "proxy"
 },
 "simapro": {
  "cb_standard": 981,
  "ts_standard": 345,
  "ram_standard": 32,
  "cb_professional": 2303,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "chemdraw": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 604,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "gaussian-gaussview": {
  "cb_standard": 981,
  "ts_standard": 345,
  "ram_standard": 32,
  "cb_professional": 2303,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "avogadro-spartan": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 604,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "orca": {
  "cb_standard": 981,
  "ts_standard": 345,
  "ram_standard": 32,
  "cb_professional": 2303,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "vmd": {
  "cb_standard": 604,
  "ts_standard": 3466,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 7788,
  "ram_professional": 32,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "proxy"
 },
 "mercury-ccdc": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 604,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "mestrenova": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 604,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "graphpad-prism": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 604,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "imagej-fiji": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 604,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "snapgene": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 604,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "geneious": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 604,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "3d-slicer": {
  "cb_standard": 604,
  "ts_standard": 3466,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 7788,
  "ram_professional": 32,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "proxy"
 },
 "r-rstudio": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "stata": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "jasp": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "eviews": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "minitab": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "mathematica": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "maple": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "nvivo": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "atlas-ti": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "qualtrics": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "sas": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "python": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "java-jdk": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "c-cpp-toolchain": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "git": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "linux-wsl": {
  "cb_standard": 775,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "nodejs-web": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "sql-databases": {
  "cb_standard": 775,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "pytorch-tensorflow": {
  "cb_standard": 775,
  "ts_standard": 9999,
  "ram_standard": 32,
  "cb_professional": 1654,
  "ts_professional": 16195,
  "ram_professional": 64,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "poor"
 },
 "hadoop-spark": {
  "cb_standard": 775,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 64,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "unity": {
  "cb_standard": 775,
  "ts_standard": 7788,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 9999,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "good"
 },
 "unreal-engine": {
  "cb_standard": 920,
  "ts_standard": 9999,
  "ram_standard": 32,
  "cb_professional": 2303,
  "ts_professional": 16195,
  "ram_professional": 64,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "good"
 },
 "fpga-vivado": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "jupyter-anaconda": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "complete-anatomy": {
  "cb_standard": 604,
  "ts_standard": 3466,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 7788,
  "ram_professional": 32,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "proxy"
 },
 "psychopy": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 604,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "e-prime": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 604,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "kinovea": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 604,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "dartfish": {
  "cb_standard": 604,
  "ts_standard": 3466,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 7788,
  "ram_professional": 32,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "proxy"
 },
 "quintic": {
  "cb_standard": 604,
  "ts_standard": 3466,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 7788,
  "ram_professional": 32,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "proxy"
 },
 "vicon-nexus": {
  "cb_standard": 604,
  "ts_standard": 3466,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 7788,
  "ram_professional": 32,
  "primary_bottleneck": "gpu",
  "gpu_axis_confidence": "proxy"
 },
 "medicinescomplete-bnf": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "passmedicine-quesmed": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "bloomberg-terminal": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "refinitiv-eikon": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "sage": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "sap-erp": {
  "cb_standard": 450,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 450,
  "ts_professional": 345,
  "ram_professional": 16,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "legal-databases": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "capital-iq": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "google-analytics": {
  "cb_standard": 330,
  "ts_standard": 345,
  "ram_standard": 8,
  "cb_professional": 330,
  "ts_professional": 345,
  "ram_professional": 8,
  "primary_bottleneck": "none",
  "gpu_axis_confidence": "poor"
 },
 "praat": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 775,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "cpu",
  "gpu_axis_confidence": "poor"
 },
 "antconc": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "elan": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 },
 "sdl-trados": {
  "cb_standard": 604,
  "ts_standard": 345,
  "ram_standard": 16,
  "cb_professional": 1654,
  "ts_professional": 345,
  "ram_professional": 32,
  "primary_bottleneck": "ram",
  "gpu_axis_confidence": "poor"
 }
};
